<template>
  <app-content class="h-panel">
    <Loading text="数据加载中..." :loading="loading"></Loading>
    <div class="h-panel-bar">
      <span class="h-panel-title">生成报表快照</span>
      <Button class="float-right" @click="$router.push({ name: 'ReportSnapshotList' })">返回</Button>
      <Button class="float-right margin-right" color="primary" :loading="generateLoading" @click="generateSnapshot">
        生成快照
      </Button>
      <Button class="float-right margin-right" color="green" :loading="previewLoading" @click="loadPreview" :disabled="!accountDate">
        刷新预览
      </Button>
    </div>

    <div class="margin-left margin-right margin-top">
      <account-date-choose v-model="accountDate" />
      <span class="tip">支持两种方式：填“调整额”，或直接改“最终值”。最终值优先。</span>
    </div>
    <div class="margin-left margin-right margin-top form-row">
      <label class="label">快照标题</label>
      <input class="h-input title-input" v-model.trim="snapshotTitle" placeholder="请输入快照标题" />
    </div>
    <div class="margin-left margin-right margin-top form-row">
      <label class="label">备注</label>
      <textarea class="h-input remark-input" v-model.trim="snapshotRemark" placeholder="可填写分享说明（选填）"></textarea>
    </div>

    <div class="h-panel-body" v-if="reports.length > 0">
      <Tabs :datas="tabDatas" v-model="activeReportKey" class="h-tabs-card" />

      <Table :datas="currentItems" border class="small-td margin-top">
        <TableItem title="项目">
          <div slot-scope="{data}" :class="{'font-bold': data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次" :width="70">
          <template slot-scope="{data}">
            {{data.isClassified ? '' : (data.lineNum > -1 ? data.lineNum : '')}}
          </template>
        </TableItem>

        <TableItem title="基准本年" align="right">
          <template slot-scope="{data}">{{ data.baseCurrentYearAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="调整本年" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.adjustCurrentYearAmount)"
              @input="onAdjustInput(data, 'CurrentYear', $event.target.value)"
            />
          </template>
        </TableItem>
        <TableItem title="最终本年" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.finalCurrentYearAmount)"
              @input="onFinalInput(data, 'CurrentYear', $event.target.value)"
            />
          </template>
        </TableItem>

        <TableItem title="基准本期" align="right">
          <template slot-scope="{data}">{{ data.baseCurrentPeriodAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="调整本期" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.adjustCurrentPeriodAmount)"
              @input="onAdjustInput(data, 'CurrentPeriod', $event.target.value)"
            />
          </template>
        </TableItem>
        <TableItem title="最终本期" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.finalCurrentPeriodAmount)"
              @input="onFinalInput(data, 'CurrentPeriod', $event.target.value)"
            />
          </template>
        </TableItem>

        <TableItem v-if="showLastYear" title="基准上年" align="right">
          <template slot-scope="{data}">{{ data.baseLastYearAmount | numFormat }}</template>
        </TableItem>
        <TableItem v-if="showLastYear" title="调整上年" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.adjustLastYearAmount)"
              @input="onAdjustInput(data, 'LastYear', $event.target.value)"
            />
          </template>
        </TableItem>
        <TableItem v-if="showLastYear" title="最终上年" align="right">
          <template slot-scope="{data}">
            <input
              v-if="!data.isClassified"
              class="cell-input"
              :value="formatInput(data.finalLastYearAmount)"
              @input="onFinalInput(data, 'LastYear', $event.target.value)"
            />
          </template>
        </TableItem>
      </Table>
    </div>
  </app-content>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ReportSnapshotGenerate',
  data() {
    return {
      accountDate: null,
      loading: false,
      previewLoading: false,
      generateLoading: false,
      reports: [],
      activeReportKey: '',
      snapshotTitle: '',
      snapshotRemark: ''
    }
  },
  computed: {
    ...mapState(['orgDatas', 'currentOrgId', 'currentAccountSets']),
    tabDatas() {
      return this.reports.map(r => ({ key: r.reportKey, title: r.reportName }));
    },
    currentReport() {
      return this.reports.find(r => r.reportKey === this.activeReportKey) || null;
    },
    currentItems() {
      return this.currentReport ? this.currentReport.items : [];
    },
    showLastYear() {
      return this.currentReport && this.currentReport.reportType === 3;
    }
  },
  watch: {
    accountDate(newVal, oldVal) {
      if (newVal && !this.snapshotTitle) {
        this.snapshotTitle = this.buildDefaultTitle();
      }
      if (newVal && newVal !== oldVal && this.reports.length === 0 && !this.previewLoading) {
        this.loadPreview();
      }
    },
    orgDatas() {
      this.initDefaultDate();
    },
    currentOrgId() {
      this.initDefaultDate();
    },
    'currentAccountSets.currentAccountDate'() {
      this.initDefaultDate();
    }
  },
  methods: {
    loadPreview() {
      if (!this.accountDate) {
        this.$Message.error('请选择会计期间');
        return;
      }
      this.previewLoading = true;
      this.loading = true;
      this.$api.report.snapshot.preview({ accountDate: this.accountDate }).then(({ data }) => {
        const reports = (data && data.reports) || [];
        this.reports = reports.map(report => this.normalizeReport(report));
        if (this.reports.length > 0) {
          this.activeReportKey = this.reports[0].reportKey;
        }
        if (!this.snapshotTitle) {
          this.snapshotTitle = this.buildDefaultTitle();
        }
      }).finally(() => {
        this.previewLoading = false;
        this.loading = false;
      });
    },
    buildDefaultTitle() {
      if (!this.accountDate) {
        return '报表快照';
      }
      const d = new Date(this.accountDate);
      if (isNaN(d.getTime())) {
        return '报表快照';
      }
      return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)} 报表快照`;
    },
    normalizeReport(report) {
      const items = (report.items || []).map(item => {
        const row = Object.assign({}, item);
        row.adjustCurrentPeriodAmount = null;
        row.adjustCurrentYearAmount = null;
        row.adjustLastYearAmount = null;
        row.finalCurrentPeriodAmount = row.baseCurrentPeriodAmount;
        row.finalCurrentYearAmount = row.baseCurrentYearAmount;
        row.finalLastYearAmount = row.baseLastYearAmount;
        row.manualOverrideCurrentPeriod = false;
        row.manualOverrideCurrentYear = false;
        row.manualOverrideLastYear = false;
        return row;
      });
      return Object.assign({}, report, { items });
    },
    onAdjustInput(row, fieldName, rawValue) {
      const adjustField = `adjust${fieldName}Amount`;
      const finalField = `final${fieldName}Amount`;
      const baseField = `base${fieldName}Amount`;
      const manualField = `manualOverride${fieldName}`;

      row[adjustField] = this.parseNumber(rawValue);
      if (!row[manualField]) {
        row[finalField] = this.calcByAdjust(row[baseField], row[adjustField]);
      }
    },
    onFinalInput(row, fieldName, rawValue) {
      const adjustField = `adjust${fieldName}Amount`;
      const finalField = `final${fieldName}Amount`;
      const baseField = `base${fieldName}Amount`;
      const manualField = `manualOverride${fieldName}`;

      const finalValue = this.parseNumber(rawValue);
      row[finalField] = finalValue;
      if (finalValue === null) {
        row[manualField] = false;
        row[finalField] = this.calcByAdjust(row[baseField], row[adjustField]);
      } else {
        row[manualField] = true;
        row[adjustField] = this.nonNull(finalValue) - this.nonNull(row[baseField]);
      }
    },
    calcByAdjust(baseValue, adjustValue) {
      if (baseValue == null && adjustValue == null) {
        return null;
      }
      return this.nonNull(baseValue) + this.nonNull(adjustValue);
    },
    parseNumber(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const n = Number(value);
      if (isNaN(n)) {
        return null;
      }
      return n;
    },
    nonNull(val) {
      return val == null ? 0 : Number(val);
    },
    formatInput(val) {
      return val == null ? '' : val;
    },
    buildAdjustments() {
      const adjustments = [];
      this.reports.forEach(report => {
        (report.items || []).forEach(row => {
          if (row.isClassified) {
            return;
          }
          const hasAdjust = this.hasNonZero(row.adjustCurrentPeriodAmount)
            || this.hasNonZero(row.adjustCurrentYearAmount)
            || this.hasNonZero(row.adjustLastYearAmount);
          const hasManual = row.manualOverrideCurrentPeriod || row.manualOverrideCurrentYear || row.manualOverrideLastYear;
          if (!hasAdjust && !hasManual) {
            return;
          }

          adjustments.push({
            reportKey: report.reportKey,
            itemId: row.itemId,
            adjustCurrentPeriodAmount: row.adjustCurrentPeriodAmount,
            adjustCurrentYearAmount: row.adjustCurrentYearAmount,
            adjustLastYearAmount: row.adjustLastYearAmount,
            finalCurrentPeriodAmount: row.manualOverrideCurrentPeriod ? row.finalCurrentPeriodAmount : null,
            finalCurrentYearAmount: row.manualOverrideCurrentYear ? row.finalCurrentYearAmount : null,
            finalLastYearAmount: row.manualOverrideLastYear ? row.finalLastYearAmount : null,
            manualOverride: hasManual
          });
        });
      });
      return adjustments;
    },
    hasNonZero(value) {
      return value != null && Number(value) !== 0;
    },
    generateSnapshot() {
      if (!this.accountDate) {
        this.$Message.error('请选择会计期间');
        return;
      }
      if (this.reports.length === 0) {
        this.$Message.error('请先加载预览');
        return;
      }
      if (!this.snapshotTitle) {
        this.$Message.error('请填写快照标题');
        return;
      }
      this.generateLoading = true;
      const params = {
        title: this.snapshotTitle,
        remark: this.snapshotRemark,
        accountDate: this.accountDate,
        adjustments: this.buildAdjustments()
      };
      this.$api.report.snapshot.generate(params).then(({ data }) => {
        this.$Message.success('快照生成成功');
        this.$router.push({ name: 'ReportSnapshotDetail', params: { snapshotId: data.snapshotId } });
      }).finally(() => {
        this.generateLoading = false;
      });
    },
    initDefaultDate() {
      if (this.accountDate) {
        return;
      }
      if (this.orgDatas && this.orgDatas.length > 0) {
        const currentOrg = this.orgDatas.find(org => org.id === this.currentOrgId) || this.orgDatas[0];
        this.accountDate = currentOrg.currentAccountDate;
      }
      if (!this.accountDate && this.currentAccountSets && this.currentAccountSets.currentAccountDate) {
        this.accountDate = this.currentAccountSets.currentAccountDate;
      }
      if (this.accountDate && !this.snapshotTitle) {
        this.snapshotTitle = this.buildDefaultTitle();
      }
    },
    pad(n) {
      return n < 10 ? `0${n}` : `${n}`;
    }
  },
  mounted() {
    this.initDefaultDate();
  }
}
</script>

<style scoped>
.margin-right {
  margin-right: 10px;
}
.tip {
  margin-left: 10px;
  color: #888;
  font-size: 12px;
}
.form-row {
  display: flex;
  align-items: center;
}
.label {
  width: 70px;
  color: #666;
}
.title-input {
  width: 360px;
}
.remark-input {
  width: 600px;
  height: 70px;
  resize: vertical;
}
.cell-input {
  width: 100%;
  border: 1px solid #dcdee2;
  border-radius: 2px;
  padding: 4px 6px;
  text-align: right;
}
.font-bold {
  font-size: 14px;
}
</style>
